// @flow

import React, { Component } from 'react';
import { TwitterIcon } from 'seek-style-guide/react';
import { hrefFromLocation } from '@seek/seek-jobs-seo/build/location';
import ShareButton from '../ShareButton/ShareButton';

function twitterUrl(location) {
  const returnUrl = hrefFromLocation({
    ...location,
    query: {
      ...location.query,
      share: 'twt'
    }
  });

  return hrefFromLocation({
    protocol: 'https:',
    hostname: 'twitter.com',
    pathname: '/share',
    query: {
      url: returnUrl,
      text: 'Check out this job on SEEK:'
    }
  });
}

type Props = {
  location: UrlLocation
};

export default class TwitterButton extends Component<Props> {
  props: Props;

  render() {
    return (
      <ShareButton
        title="Share on Twitter"
        type="twitter"
        icon={TwitterIcon}
        href={twitterUrl(this.props.location)}
        popupWidth={620}
        popupHeight={338}
      />
    );
  }
}
